// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('UserProfileFeedEmptySelfPosts')

function EmptySelfPostsMessage(props) {
  return tag('div', {
    className: classNames(
      props.className,
      bem.block()
    )
  },
    tag('div', {
      className: bem.element('inner'),
      onClick: props.onAddUrlClick
    },
      tag('div', {
        className: bem.element('heading')
      },
        'Content you save to Mix will appear here.'
      ),
      tag('div', {
        className: bem.element('subheading')
      },
        tag('div', {
          className: bem.element('button')
        }),
        'Get started by adding a link!'
      )
    )
  )
}

EmptySelfPostsMessage.propTypes = {
  className: PropTypes.string,
  onAddUrlClick: PropTypes.func
}

module.exports = EmptySelfPostsMessage
